const REGEX_VALID={
    email_regex : '^[A-Za-z0-9._%+-]{1,64}[@][A-Za-z0-9-]+[.][A-Za-z]',
    password_regex : '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~`!@#\\$%^&*()_+={[}\\]|:;"\'<,>.?\\/]).{8,30}$',
    firstName_regex : '^[A-Za-z ]{2,30}$',
    lastName_regex : '^[A-Za-z .,]{1,40}$',
    companyName_regex : '^(?=.*[a-zA-Z0-9])(?=.{2,40}$)',
    productName_regex : '^(?=.*[a-zA-Z0-9])(?=.{1,80}$)',
    skuCode_regex : '[a-zA-Z0-9_]{3,12}$',
    setsCode_regex :  '[a-zA-Z0-9_]{3,40}$',
    roleName_regex :   '^(?=.*[a-zA-Z0-9])(?=.{1,80}$)',
};
export default REGEX_VALID;